import {
    getAPIGatewayDataFromParent,
    getSortPathGeneratorAPIGatewayRequest
} from "../handler/ParentDataHandler";

export const GET_PATH_SCHEDULE_ENDPOINT = '/spg/pathschedule/get';
export const SET_PATH_SCHEDULE_ENDPOINT = '/spg/pathschedule/set';
export const DELETE_PATH_SCHEDULE_ENDPOINT = '/spg/pathschedule/delete';

/**
 * Fetches the active and staged path schedules for a station + cycle.
 *
 * GetPathSchedule is scoped to a single station+cycle combination. The backend
 * request field is `cycleId`, but its value is the cycle *name* (e.g. "CYCLE_1"),
 * because the PathSchedule partition key is {stationCode}_{cycleId} and the backend,
 * SortPathSetting/SortPathInfo, and reservation/constraints flows all identify a cycle
 * by name (not the cycle UUID). Each cycle's schedules must be fetched independently.
 * An optional date range (fromDate/toDate) filters the staged entries server-side.
 *
 * @param nodeId station code
 * @param cycleId cycle identifier (the cycle *name*, e.g. "CYCLE_1") whose schedules to retrieve
 * @param fromDate optional inclusive lower bound (date-only or date-time string)
 * @param toDate optional inclusive upper bound (date-only or date-time string)
 * @returns {Promise<*>} GetPathScheduleOutput { activeSchedule, stagedSchedules } or errorResponse
 */
export async function getPathSchedule(nodeId, cycleId, fromDate, toDate) {
    const requestBody = {
        stationCode: nodeId,
        cycleId: cycleId,
        fromDate: fromDate,
        toDate: toDate
    };

    const request = getSortPathGeneratorAPIGatewayRequest(GET_PATH_SCHEDULE_ENDPOINT, requestBody);
    const response = await getAPIGatewayDataFromParent(request);
    return response ? (response.data || response.errorResponse) : response;
}
